const { Component, render, findDOMNode, Fragment } = wp.element;
import Loader from 'react-loader-spinner'
import axios from 'axios';

import {
  IMAGE_EDITOR_isset as isset
} from "./utils.js";



const alias = 'AA_2Performant-Frontend-'
class AA_2PerformantProductSync extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      last_sync_date: false,
      code: false,
      ID: false,
      sync_in_progress: false
    };

    const data = JSON.parse( this.props.data );
    if( data ){
      this.state.code = data.code;
      this.state.ID = data.ID;


      this.call_for_sync();
    }
  }

  call_for_sync()
  {
    this.state.sync_in_progress = true;

    axios.post( AA_2Performant.ajax_url, {
      ID: this.state.ID,
      sub_action: 'sync_product'
    })
    .then(res => {

      const { data } = res;

      if( data.data === true ){
        window.location.reload();
      }

      this.setState({
        sync_in_progress: false
      })
    })
  }

  render() {

    const { sync_in_progress } = this.state;

    if( sync_in_progress ){
      return <div className={ `${alias}sync-loading` }>
        <Loader
          type="TailSpin"
          color="#ee1f34"
          height="40"
          width="40"
        />
        <span>synchronize product in progress ...</span>
      </div>
    }

    return <Fragment></Fragment>
  }
}

export { AA_2PerformantProductSync };



// WEBPACK FOOTER //
// ./src/sync.js